// app/javascript/dashboard.js
// Dashboard & Layout Shell Orchestrator (CSP-compliant, Turbo-resilient)
// Replaces inline onclick handlers and inline script tags

(function () {
  const KNOWN_DISMISS_BANNERS = ['free_daily_throttle', 'quota_warning_80']

  function checkDismissedBanners () {
    KNOWN_DISMISS_BANNERS.forEach(function (id) {
      try {
        if (sessionStorage.getItem('dismiss_banner_' + id) === 'true') {
          const bannerEl = document.getElementById('banner_' + id) || document.querySelector(`[data-banner-id="${id}"]`)
          if (bannerEl) bannerEl.remove()
        }
      } catch (e) {
        // sessionStorage may be blocked in strict private browsing
      }
    })
  }

  // Restore banner state on Turbo navigation and DOM load
  document.addEventListener('turbo:load', checkDismissedBanners)
  document.addEventListener('turbo:render', checkDismissedBanners)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkDismissedBanners)
  } else {
    checkDismissedBanners()
  }

  // Global delegated click listener for shell and dashboard interactions
  document.addEventListener('click', function (e) {
    // 1. Open Onboarding Video Modal (Folio / Cohort)
    const videoBtn = e.target.closest('[data-action="open-onboarding-video"], [data-cohort-action="watch-tutorial"]')
    if (videoBtn) {
      e.preventDefault()
      e.stopPropagation()
      const modalType = videoBtn.dataset.modalType || videoBtn.getAttribute('data-modal-type') || (videoBtn.dataset.cohortAction === 'watch-tutorial' ? 'cohort' : 'folio')
      const modal = document.querySelector(`onboarding-video-modal[data-modal-type='${modalType}']`)
      if (modal && typeof modal.open === 'function') {
        modal.open()
      }
      return
    }

    // 2. Restart Tour
    const restartTourBtn = e.target.closest('[data-action="restart-tour"]')
    if (restartTourBtn) {
      e.preventDefault()
      e.stopPropagation()
      if (document.querySelector('app-tour-start')) {
        window.dispatchEvent(new CustomEvent('doccu:restart-tour'))
      } else {
        window.location.href = '/?start_tour=true'
      }
      return
    }

    // 3. Dismiss Banner
    const dismissBannerBtn = e.target.closest('[data-dismiss-banner]')
    if (dismissBannerBtn) {
      e.preventDefault()
      e.stopPropagation()
      const bannerId = dismissBannerBtn.dataset.dismissBanner || dismissBannerBtn.getAttribute('data-dismiss-banner')
      if (bannerId) {
        try {
          sessionStorage.setItem('dismiss_banner_' + bannerId, 'true')
        } catch (err) {
          // ignore
        }
        const bannerEl = document.getElementById('banner_' + bannerId) ||
                         dismissBannerBtn.closest(`[data-banner-id="${bannerId}"]`) ||
                         dismissBannerBtn.closest(`#banner_${bannerId}`) ||
                         dismissBannerBtn.closest('.alert, [class*="bg-[#fef3c7]"], [class*="bg-[#fee2e2]"]')
        if (bannerEl) {
          bannerEl.remove()
        }
      }
    }
  })
})()
